import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import * as api from "./seoApi";

export const fetchSeoMeta = createAsyncThunk("seo/fetchSeoMeta", async (_, { getState, rejectWithValue }) => {
  try {
    const token = getState().user.user.token;
    const res = await api.getSeoMeta(token);
    return res.data;
  } catch (err) {
    return rejectWithValue(err?.response?.data?.message || err?.message || "Failed to fetch SEO records");
  }
});

export const upsertSeoMeta = createAsyncThunk("seo/upsertSeoMeta", async ({ pageKey, data }, { getState, rejectWithValue }) => {
  try {
    const token = getState().user.user.token;
    const res = await api.upsertSeoMeta({ pageKey, ...data }, token);
    toast.success("SEO settings saved successfully");
    return res.data;
  } catch (err) {
    const msg = err?.response?.data?.message || err?.message || "Failed to save SEO settings";
    toast.error(msg);
    return rejectWithValue(msg);
  }
});

export const deleteSeoMeta = createAsyncThunk("seo/deleteSeoMeta", async (id, { getState, rejectWithValue }) => {
  try {
    const token = getState().user.user.token;
    await api.deleteSeoMeta(id, token);
    toast.success("SEO record deleted");
    return id;
  } catch (err) {
    const msg = err?.response?.data?.message || err?.message || "Failed to delete SEO record";
    toast.error(msg);
    return rejectWithValue(msg);
  }
});

const seoSlice = createSlice({
  name: "seo",
  initialState: { records: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSeoMeta.pending,   (state) => { state.loading = true; state.error = null; })
      .addCase(fetchSeoMeta.fulfilled, (state, action) => {
        state.loading = false;
        state.records = action.payload?.records || action.payload || [];
      })
      .addCase(fetchSeoMeta.rejected,  (state, action) => { state.loading = false; state.error = action.payload; })

      .addCase(upsertSeoMeta.fulfilled, (state, action) => {
        const record = action.payload?.seoMeta || action.payload;
        if (record?._id) {
          const idx = state.records.findIndex((r) => r._id === record._id || r.pageKey === record.pageKey);
          if (idx !== -1) state.records[idx] = record;
          else state.records.push(record);
        }
      })
      .addCase(upsertSeoMeta.rejected, (state, action) => { state.error = action.payload; })

      .addCase(deleteSeoMeta.fulfilled, (state, action) => {
        state.records = state.records.filter((r) => r._id !== action.payload);
      })
      .addCase(deleteSeoMeta.rejected, (state, action) => { state.error = action.payload; });
  },
});

export default seoSlice.reducer;
